import { Logo } from "./Logo";
import logoIcon from "@/assets/logo-icon.png";
import logoHorizontal from "@/assets/logo-horizontal.png";

// Easy logo configuration - change these values to customize the logo
export const LOGO_CONFIG = {
  // Size presets
  sizes: {
    nav: "md" as const,
    header: "xl" as const,
    certificate: "lg" as const,
    mobile: "sm" as const,
  },
  
  // Static image assets for external use
  assets: {
    icon: logoIcon,
    horizontal: logoHorizontal,
  }
};

// Pre-configured logo components for different use cases
export const NavLogo = () => (
  <Logo size={LOGO_CONFIG.sizes.nav} theme="dark" />
);

export const HeaderLogo = () => (
  <Logo size={LOGO_CONFIG.sizes.header} />
);

export const CertificateLogo = () => (
  <Logo size={LOGO_CONFIG.sizes.certificate} />
);

export const MobileLogo = () => (
  <Logo size={LOGO_CONFIG.sizes.mobile} variant="icon-only" />
);

// Export assets for external use
export { logoIcon, logoHorizontal };

// Main export
export { Logo };